import { defineMessages } from 'react-intl';

export default defineMessages({
  phatty: { defaultMessage: 'phatty' },
  phux: { defaultMessage: 'phux' },
  phame: { defaultMessage: 'phame' },
  tele: { defaultMessage: 'Telegram' },
  twitter: { defaultMessage: 'Twitter' },
});
